import React, { useEffect, useState } from 'react'

// Appt Components
import Select from '../../../components/simple/input/Select'

const OperatorBox = (props) => {
  const [operatorOptions, setOperatorOptions] = useState([])

  const autoCompleteQueries = ['is', 'is not']
  const booleanQueries = ['is', 'is not']
  const dateQueries = ['on', 'after', 'before']
  const integerQueries = ['equal to', 'not equal to', 'greater than', 'less than', 'greater than or equal', 'less than or equal']
  const listQueries = ['is', 'is not']
  const timeQueries = ['is', 'after', 'before'] // ['on', 'after', 'before']

  const [query, setQuery] = useState(props.query || {})
  useEffect(() => { 
    setQuery(props.query || {}) 
  }, [props.query])

  const [type, setType] = useState(props.type || '')
  useEffect(() => { setType(props.type || '') }, [props.type])

  const [operators, setOperators] = useState(props.operators || [])
  useEffect(() => { setOperators(props.operators || []) }, [props.operators])

  const [index, setIndex] = useState(props.index || 0)
  useEffect(() => { setIndex(props.index || 0) }, [props.index])

  useEffect(() => {
    // don't replace type if it has a value
    // if (!type?.length > 0) {
      if (query?.[`Field-${index}`]?.type) {
        setType(query[`Field-${index}`].type)
      }
    // }

    if (!operators?.length > 0) {
      if (query?.[`Field-${index}`]?.operators) {
        setOperators(query[`Field-${index}`].operators)
      } else {
        // props.setDefaultOperatorValue(operatorOptions[0], index)
      }
    }

  }, [query, index, type, operators, operatorOptions, props])

  useEffect(() => {
    // Set operator options based on field datatype
    const setOperator = async () => {
      
      switch (type) {
        case 'autoComplete':
          setOperatorOptions(autoCompleteQueries)
          break
        case 'boolean':
        case 'yesno':
          setOperatorOptions(booleanQueries)
          break
        case 'date':
          setOperatorOptions(dateQueries)
          break
        case 'integer':
          setOperatorOptions(integerQueries)
          break
        case 'list':
          setOperatorOptions(listQueries)
          break
        case 'time':
          setOperatorOptions(timeQueries)
          break
        default:
          setOperatorOptions(autoCompleteQueries)
      }
    }

    setOperator()
  }, [type, operators, query])


  
  return (
    <>
      <Select
        // defaultValue={operatorOptions[0]}
        options={operatorOptions}
        // value={props.value || operatorOptions[0]}
        // value={operatorOptions[0]}
        {...props}
        // id='student'
        //   disabled={props.userId !== 'new'}
        //   name={questions[0].key}
        // labelKey='questionText'

        // valueKey={{ key: 'id', reduce: true }}
      />
    </>
  )
}

export default OperatorBox
